export const place = {
  public: true,
  pages: ["entrar", "convite", "vincular", "retorno", "fator", "acesso", "bem-vindo"].map((step) => ({ id: `acesso-${step}`,
    path: `/conta/${step}` })),
  welcome: "/conta/bem-vindo",
} as const;
